import { CardStandart } from 'ui/CardStandart'
import { TypographyHeader } from 'ui/typography/TypographyHeader'

import { IGroupEntity } from 'models'
import GroupSpecificData from './GroupSpecificData'

const GroupSpecificInfo = (props: IGroupEntity) => {
	return (
		<CardStandart
			sx={{
				display: 'flex',
				flexDirection: 'column',
				padding: '24px',
				height: 'auto',
				flexShrink: 0,
				width: '100%',
			}}
		>
			<TypographyHeader>Основная информация</TypographyHeader>
			<GroupSpecificData {...props} />
		</CardStandart>
	)
}

export default GroupSpecificInfo
